module.exports = __webpack_public_path__ + "assets/img/forum2.bfc8a65d.png";